<div class="container d-flex flex-column flex-xl-row justify-content-between align-items-center one-side-page" [ngClass]="landing_class">
  <div class="logo-section d-flex flex-column justify-content-center align-items-end">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <img [src]="logo" [routerLink]="'/'" class="aging-logo" alt="Aging Plan" />
      <div class="d-none d-xl-block">
        <p class="grey logo-text">RECOGNIZED LEADER IN</p>
        <p class="text-light logo-text">LONG-TERM CARE</p>
        <p class="grey logo-text">INSURANCE PLANNING</p>
      </div>
    </div>
  </div>
  <div class="vertical-line d-none d-xl-block"></div>
  <div class="rightside-login">
    <ng-content></ng-content>
  </div>
  <div class="d-xl-none text-logo">
    <p class="grey logo-text">RECOGNIZED LEADER IN</p>
    <p class="text-light logo-text">LONG-TERM CARE</p>
    <p class="grey logo-text">INSURANCE PLANNING</p>
  </div>
</div>
